const SEARCH_FIELD = {
  BRANCH_ID: "branch_id",
  TO_DATE: "to_date",
  FROM_DATE: "from_date",
};

export { SEARCH_FIELD };
